import './rev&BudInput.css';
import { useState, useEffect } from 'react';

import Swatch from '../../../assets/icons/swatch/swatch';

export default function RevBudInput({organizationData, analyticsTime, handleRevChange,  handleBudgChange}) { 

    const [revenueInput, setRevenueInput] = useState('');
    const [budgetInput, setBudgetInput] = useState('');

    useEffect(() => {
    setRevenueInput('');
    setBudgetInput('');
  }, [analyticsTime]);

  const onRevenueChange = (e) => {
    setRevenueInput(e.target.value);
    handleRevChange(e, analyticsTime);
  };

  const onBudgetChange = (e) => {
    setBudgetInput(e.target.value);
    handleBudgChange(e, analyticsTime);
  };

    return ( 
        <div className="revbudinput card">
            <div className="revbudinput-container">

                <div className="revbudinput-input">
                    <Swatch swatch={'var(--secondary-color)'}/>
                    <input type="number" name={"revenue"} value={revenueInput} placeHolder={organizationData[analyticsTime].revenue}
                        onChange={onRevenueChange}
                    ></input>
                </div>
                
                <div className="revbudinput-input">
                    <Swatch swatch={'var(--budget-color)'}/> 
                    <input type="number" name={"budget"} value={budgetInput} placeHolder={organizationData[analyticsTime].budget}
                        onChange={onBudgetChange}
                    ></input>
                </div>
                
            </div> 
        </div>
    )
}